import { baseBuild } from '@/core/services/network/config/baseBuild';
import type { AppDispatch } from '@/app/store/store';
import { createSizerService } from '../application/services/SizerService';
import { SizerAdapter } from '../infra/adapters/sizer.adapter';

export function sizerBuild(dispatch: AppDispatch) {
  return baseBuild(
    (d: AppDispatch) => new SizerAdapter(d),
    (repo) => createSizerService(repo),
    dispatch,
  );
}
